export enum HeaderButtonType {
  Video = 'VIDEO',
  Call = 'CALL',
  OpenList = 'OPEN_LIST',
  OrderCancel = 'ORDER_CANCEL',
  MyOeamtc = 'MY_OEAMTC',
}

export enum FooterButtonType {
  Text = 'TEXT',
  Album = 'ALBUM',
  Camera = 'CAMERA',
  WebCamera = 'WEB_CAMERA',
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Location = 'LOCATION',
  MsgPhoto = 'MSG_PHOTO',
  MsgVideo = 'MSG_VIDEO',
  MsgCallback = 'MSG_CALLBACK',
  MsgLocation = 'MSG_LOCATION',
  MsgTowingDest = 'MSG_TOWING_DEST',
  MsgVehicleData = 'MSG_VEHICLE_DATA',
  MsgPassengers = 'MSG_PASSENGERS',
  MsgChecklist = 'MSG_CHECKLIST',
  MsgSurvey = 'MSG_SURVEY',
}

export enum SidebarButtonType {
  BarOpen = 'OPEN',
  BarCollapse = 'COLLAPSE',
  Close = 'CLOSE',
  More = 'MORE',
  File = 'FILE',
  Image = 'IMAGE',
  Video = 'VIDEO',
  Speak = 'SPEAK',
  Call = 'CALL',
  Archive = 'ARCHIVE',
  Unarchive = 'UNARCHIVE',
  Share = 'SHARE',
  Notify = 'NOTIFY',
  Participants = 'PARTICIPANTS',
  Join = 'JOIN',
  Flag = 'FLAG',
  Lock = 'LOCK',
  Unlock = 'UNLOCK',
}

export interface SidebarButtonEvent {
  buttonType: SidebarButtonType;
  target: Element;
}

export interface ConversationParticpantFormData {
  name: string;
  id: string;
  phone?: string;
  email?: string;
}

export interface ConversationFormData {
  id: string;
  participants: ConversationParticpantFormData[];
  type: string;
  data?: string;
  description?: string;
}

export interface ConversationFormDialogResult {
  eventType: 'SAVE' | 'CANCEL';
  data?: ConversationFormData;
}

export interface ConversationFilters {
  showArchived?: boolean;
  search?: string;
}

export enum ProgressionStateType {
  None,
  Current,
  Done,
}
